(() => {
  const roots = document.querySelectorAll('[data-qpc-root]');
  if (!roots.length) return;

  const STEPS = [
    { key:'cpu', label:'Processor', title:'Choose your processor', desc:'Choose AMD or Intel first. The CPU defines the platform and compatible boards are filtered automatically.' },
    { key:'motherboard', label:'Motherboard', title:'Choose a motherboard', desc:'Only motherboards matching your selected CPU platform are prioritized.' },
    { key:'gpu', label:'Graphics Card', title:'Choose your graphics card', desc:'Your GPU has the biggest impact on gaming resolution and PSU requirements.' },
    { key:'ram', label:'Memory', title:'Choose your memory', desc:'RAM generation is matched to the motherboard. Select a RAM model, then choose how many pieces you want.' },
    { key:'storage', label:'Storage', title:'Choose your NVMe storage', desc:'Select the capacity and performance tier that fits the build.' },
    { key:'case', label:'Case', title:'Choose your case', desc:'Switch between Combo Case and Case Only. Combo cases with an included PSU automatically skip the separate Power Supply step.' },
    { key:'psu', label:'Power Supply', title:'Choose your power supply', desc:'This step is skipped automatically when your selected case already includes a power supply.' },
    { key:'cooler', label:'CPU Cooler', title:'Choose cooling', desc:'CPU coolers and thermal paste are separated into tabs. Thermal paste is optional.' }
  ];

  const esc = (s='') => String(s).replace(/[&<>'"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]));
  const norm = (s='') => String(s).toUpperCase().replace(/[–—]/g,'-');
  const num = v => Number(String(v ?? 0).replace(/[^0-9.]/g,'')) || 0;
  const regexEscape = (s='') => String(s).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  roots.forEach(init);

  function init(root){
    const state = {
      step:0,
      products:{},
      selected:{},
      generated:null,
      upgrade:null,
      fetching:{},
      cpuBrand:'',
      caseTab:'combo',
      coolerTab:'cooler',
      inStockOnly: root.dataset.inStockOnly === 'true'
    };
    const currency = root.dataset.currency || 'EGP';
    const rootUrl = (root.dataset.rootUrl || '/').replace(/\/$/,'');
    const handles = Object.fromEntries(STEPS.map(s => [s.key, root.dataset[s.key] || s.key]));
    const discountPrefix = (root.dataset.discountPrefix || 'PCBUILDER_DISCOUNT').trim();
    const discountMessage = (root.dataset.discountMessage || 'Your discount will be applied after order confirmation / سيتم تطبيق الخصم بعد تأكيد الطلب').trim();
    const storeName = (root.dataset.storeName || 'Quantum Technology').trim();
    const $ = s => root.querySelector(s);
    const $$ = s => [...root.querySelectorAll(s)];
    const money = value => {
      try { return new Intl.NumberFormat('en-EG',{style:'currency',currency,maximumFractionDigits:0}).format(value).replace('EGP','LE'); }
      catch(e){ return `LE ${Math.round(value).toLocaleString()}`; }
    };

    renderSteps();
    bindModes();
    bindBuilder();
    bindCpuBrands();
    bindCategoryTabs();
    bindAuto();
    bindUpgrade();
    updateBuilder();

    function toast(message, error=false){
      const el = $('[data-toast]');
      el.textContent = message;
      el.classList.toggle('is-error', error);
      el.classList.add('is-visible');
      clearTimeout(el._t);
      el._t = setTimeout(()=>el.classList.remove('is-visible'),2800);
    }

    function bindModes(){
      $$('[data-mode]').forEach(btn => btn.addEventListener('click',()=>{
        const mode = btn.dataset.mode;
        $$('[data-mode]').forEach(b=>{ b.classList.toggle('is-active',b===btn); b.setAttribute('aria-selected', b===btn ? 'true':'false'); });
        $$('[data-panel]').forEach(p=>{ const active=p.dataset.panel===mode; p.classList.toggle('is-active',active); p.hidden=!active; });
        syncLoading();
      }));
    }

    function bindBuilder(){
      $('[data-prev]').addEventListener('click',()=>{ const prev=previousStepIndex(state.step); if(prev!==state.step){ state.step=prev; updateBuilder(); } });
      $('[data-next]').addEventListener('click',()=>{ const next=nextStepIndex(state.step); if(next!==state.step){ state.step=next; updateBuilder(); } });
      $('[data-search]').addEventListener('input',renderProducts);
      $('[data-sort]').addEventListener('change',renderProducts);
      $('[data-reset]').addEventListener('click',()=>{
        state.selected={};
        state.cpuBrand='';
        state.caseTab='combo';
        state.coolerTab='cooler';
        updateBuilder();
        toast('Build cleared.');
      });
      $('[data-add-cart]').addEventListener('click',()=>addSelectionToCart(state.selected));
      $('[data-share-image]')?.addEventListener('click',()=>shareBuild(state.selected,'image'));
      $('[data-share-pdf]')?.addEventListener('click',()=>shareBuild(state.selected,'pdf'));
    }

    function bindCpuBrands(){
      $$('[data-cpu-brand]').forEach(btn=>btn.addEventListener('click', async ()=>{
        const nextBrand=btn.dataset.cpuBrand;
        if(!nextBrand) return;
        if(state.cpuBrand !== nextBrand){
          state.cpuBrand=nextBrand;
          const selectedCpu=state.selected.cpu;
          if(selectedCpu && detectCpuBrand(selectedCpu)!==nextBrand){
            delete state.selected.cpu;
            delete state.selected.motherboard;
            delete state.selected.ram;
            delete state.selected.cooler;
          }
          renderSummary();
          renderStepsState();
        }
        syncCpuBrandUI();
        await ensureProducts('cpu');
        if(STEPS[state.step].key==='cpu') renderProducts();
      }));
    }

    function bindCategoryTabs(){
      $$('[data-case-tab]').forEach(btn=>btn.addEventListener('click',()=>{
        state.caseTab=btn.dataset.caseTab||'combo';
        syncCategoryTabs();
        if(STEPS[state.step].key==='case') renderProducts();
      }));
      $$('[data-cooler-tab]').forEach(btn=>btn.addEventListener('click',()=>{
        state.coolerTab=btn.dataset.coolerTab||'cooler';
        syncCategoryTabs();
        if(STEPS[state.step].key==='cooler') renderProducts();
      }));
    }

    function syncCategoryTabs(){
      const key=STEPS[state.step].key;
      const caseTabs=$('[data-case-tabs]');
      const coolerTabs=$('[data-cooler-tabs]');
      if(caseTabs) caseTabs.hidden=key!=='case';
      if(coolerTabs) coolerTabs.hidden=key!=='cooler';
      $$('[data-case-tab]').forEach(btn=>{
        const active=btn.dataset.caseTab===state.caseTab;
        btn.classList.toggle('is-active',active);
        btn.setAttribute('aria-pressed',active?'true':'false');
      });
      $$('[data-cooler-tab]').forEach(btn=>{
        const active=btn.dataset.coolerTab===state.coolerTab;
        btn.classList.toggle('is-active',active);
        btn.setAttribute('aria-pressed',active?'true':'false');
      });
    }

    function itemQty(product){
      const q=Number(product?.quantity||1);
      return Math.max(1,Math.min(4,Number.isFinite(q)?q:1));
    }

    function isComboCaseProduct(product){
      return !!product?.meta?.combo;
    }

    function comboCaseSelected(){
      return isComboCaseProduct(state.selected.case);
    }

    function isStepSkipped(index){
      return STEPS[index]?.key==='psu' && comboCaseSelected();
    }

    function activeStepIndices(){
      return STEPS.map((_,i)=>i).filter(i=>!isStepSkipped(i));
    }

    function nextStepIndex(index){
      for(let i=index+1;i<STEPS.length;i++) if(!isStepSkipped(i)) return i;
      return index;
    }

    function previousStepIndex(index){
      for(let i=index-1;i>=0;i--) if(!isStepSkipped(i)) return i;
      return index;
    }

    function requiredKeys(){
      const keys=['cpu','motherboard','gpu','ram','storage','case'];
      if(!comboCaseSelected()) keys.push('psu');
      return keys;
    }

    function renderSteps(){
      $('[data-steps-list]').innerHTML = STEPS.map((s,i)=>`<button type="button" class="qpc__step" data-step="${i}"><span class="qpc__step-dot">${String(i+1).padStart(2,'0')}</span><span class="qpc__step-name">${s.label}</span><span class="qpc__step-price"></span></button>`).join('');
      $$('[data-step]').forEach(btn=>btn.addEventListener('click',()=>{ state.step=Number(btn.dataset.step); updateBuilder(); }));
    }

    async function updateBuilder(){
      if(isStepSkipped(state.step)) state.step=nextStepIndex(state.step);
      const requestedStep = state.step;
      const step = STEPS[requestedStep];
      const active=activeStepIndices();
      const activePos=Math.max(0,active.indexOf(requestedStep));
      $('[data-step-kicker]').textContent = `STEP ${String(activePos+1).padStart(2,'0')}`;
      $('[data-step-title]').textContent = step.title;
      $('[data-step-description]').textContent = step.desc;
      $('[data-progress-text]').textContent = `${activePos+1} / ${active.length}`;
      $('[data-progress-bar]').style.width = `${((activePos+1)/active.length)*100}%`;
      $('[data-prev]').disabled = previousStepIndex(requestedStep) === requestedStep;
      $('[data-next]').textContent = nextStepIndex(requestedStep) === requestedStep ? 'Review build ✓' : 'Next component →';
      $$('[data-step]').forEach((btn,i)=>{
        const key=STEPS[i].key, p=state.selected[key];
        const skipped=isStepSkipped(i);
        const number=active.indexOf(i)+1;
        btn.hidden=skipped;
        btn.classList.toggle('is-skipped',skipped);
        btn.classList.toggle('is-active',i===requestedStep&&!skipped);
        btn.classList.toggle('is-complete',!!p&&!skipped);
        btn.querySelector('.qpc__step-dot').textContent = p ? '✓' : String(Math.max(number,1)).padStart(2,'0');
        btn.querySelector('.qpc__step-price').textContent = p ? (key==='ram'&&itemQty(p)>1?`${itemQty(p)} × ${money(p.price)}`:money(p.price)) : '';
      });
      renderSummary();
      $('[data-search]').value='';
      $('[data-sort]').value='featured';
      syncCpuBrandUI();
      if(step.key==='case' && state.selected.case) state.caseTab=isComboCaseProduct(state.selected.case)?'combo':'only';
      if(step.key==='cooler'){
        if(state.selected.thermal && !state.selected.cooler) state.coolerTab='thermal';
        else state.coolerTab='cooler';
      }
      syncCategoryTabs();

      if(step.key==='cpu' && !state.cpuBrand){
        $('[data-products]').innerHTML='';
        $('[data-empty]').hidden=true;
        syncLoading();
        return;
      }

      await ensureProducts(step.key);
      if(state.step !== requestedStep) return;
      renderProducts();
    }

    function syncCpuBrandUI(){
      const isCpu = STEPS[state.step].key === 'cpu';
      const picker = $('[data-cpu-brand-picker]');
      const toolbar = $('[data-toolbar]');
      picker.hidden = !isCpu;
      toolbar.hidden = isCpu && !state.cpuBrand;
      $$('[data-cpu-brand]').forEach(btn=>{
        const active = isCpu && btn.dataset.cpuBrand===state.cpuBrand;
        btn.classList.toggle('is-active',active);
        btn.setAttribute('aria-pressed',active?'true':'false');
      });
      if(isCpu){
        $('[data-next]').disabled = !state.cpuBrand;
      } else {
        $('[data-next]').disabled = false;
      }
    }

    function syncLoading(){
      const currentKey = STEPS[state.step].key;
      const builderActive = $('[data-panel="builder"]')?.classList.contains('is-active');
      $('[data-loading]').hidden = !(builderActive && state.fetching[currentKey]);
    }

    async function fetchJsonWithTimeout(url, timeout=15000){
      const controller = new AbortController();
      const timer = setTimeout(()=>controller.abort(), timeout);
      try{
        const response = await fetch(url,{credentials:'same-origin',signal:controller.signal,headers:{'Accept':'application/json'}});
        if(!response.ok) throw new Error(`Request returned ${response.status}`);
        return await response.json();
      } finally {
        clearTimeout(timer);
      }
    }

    async function ensureProducts(key){
      if(state.products[key]) return state.products[key];
      if(state.fetching[key]) return state.fetching[key];
      const handle=handles[key];
      $('[data-empty]').hidden=true;
      state.fetching[key] = (async()=>{
        try{
          const data = await fetchJsonWithTimeout(`${rootUrl}/collections/${encodeURIComponent(handle)}/products.json?limit=250`);
          const list=(data.products||[]).map(product=>normalizeProduct(product,key)).filter(Boolean);
          state.products[key]=list;
          if(!list.length){
            const n=$('[data-global-notice]');
            n.hidden=false;
            n.textContent=`The ${key} collection (${handle}) loaded but returned no products.`;
          }
          return list;
        }catch(err){
          console.error('[Quantum PC Builder]',err);
          const n=$('[data-global-notice]');
          n.hidden=false;
          n.textContent=`Could not load the ${key} collection (${handle}). Check the collection handle in Theme Editor and try again.`;
          state.products[key]=[];
          return [];
        }finally{
          delete state.fetching[key];
          syncLoading();
        }
      })();
      syncLoading();
      return state.fetching[key];
    }

    function normalizeTags(tags){
      if(Array.isArray(tags)) return tags.map(t=>String(t).trim()).filter(Boolean);
      if(typeof tags==='string') return tags.split(',').map(t=>t.trim()).filter(Boolean);
      return [];
    }

    function normalizeProduct(product,key){
      const variants=product.variants||[];
      const available=variants.find(v=>v.available!==false) || variants[0];
      if(!available) return null;
      const price=num(available.price);
      const image=(product.images&&product.images[0]&&product.images[0].src) || (product.image&&product.image.src) || '';
      const title=product.title||'';
      const tags=normalizeTags(product.tags);
      const vendor=product.vendor||'';
      const meta=parseMeta(key,`${title} ${vendor} ${tags.join(' ')}`);
      return {
        key,
        id:String(product.id),
        variantId:available.id,
        title,
        handle:product.handle,
        vendor,
        price,
        image,
        available:available.available!==false,
        tags,
        type:product.product_type||'',
        meta,
        discount:parseDiscount(tags,price)
      };
    }

    function parseDiscount(tags, price){
      const aliases=[discountPrefix,'PCBUILDER_DISCOUNT','PC_BUILDER_DISCOUNT','PC BUILDER DISCOUNT','BUILDER_DISCOUNT']
        .map(x=>String(x||'').trim()).filter(Boolean);
      for(const rawTag of tags||[]){
        const tag=String(rawTag).trim();
        for(const alias of aliases){
          const re=new RegExp(`^${regexEscape(alias)}\\s*[:=_-]\\s*([0-9]+(?:[.,][0-9]+)?)\\s*(%)?\\s*$`,'i');
          const match=tag.match(re);
          if(!match) continue;
          const value=Number(match[1].replace(',','.'))||0;
          if(value<=0) return 0;
          if(match[2]) return Math.min(price, price*Math.min(value,100)/100);
          return Math.min(price,value);
        }
      }
      return 0;
    }

    function parseMeta(key,text){
      const t=norm(text); const meta={};
      if(key==='cpu'){ meta.socket=cpuSocket(t); meta.cpuBrand=cpuBrandFromText(t); }
      if(key==='motherboard'){
        meta.socket=boardSocket(t);
        meta.ddr=memoryType(t);
        if(!meta.ddr){
          if(meta.socket==='AM4'||meta.socket==='LGA1200') meta.ddr='DDR4';
          if(meta.socket==='AM5'||meta.socket==='LGA1851') meta.ddr='DDR5';
        }
        meta.form=boardForm(t);
      }
      if(key==='ram') meta.ddr=memoryType(t);
      if(key==='gpu'){ meta.psu=requiredPsu(t); meta.score=gpuScore(t); meta.brand=/\b(RX|RADEON)\b/.test(t)?'amd':/\b(RTX|GTX|GEFORCE)\b/.test(t)?'nvidia':'other'; }
      if(key==='case'){ meta.combo=isComboCaseText(t); meta.comboWatts=meta.combo?watts(t):0; }
      if(key==='psu') meta.watts=watts(t);
      if(key==='cooler'){ meta.thermal=isThermalPasteText(t); meta.sockets=meta.thermal?[]:coolerSockets(t); }
      return meta;
    }

    function cpuBrandFromText(t){
      if(/\bAMD\b|\bRYZEN\b|\bATHLON\b/.test(t)) return 'amd';
      if(/\bINTEL\b|\bCORE\b|\bCELERON\b|\bPENTIUM\b|\bI[3579][ -]?\d{4,5}\b/.test(t)) return 'intel';
      return '';
    }

    function detectCpuBrand(product){
      return product?.meta?.cpuBrand || cpuBrandFromText(norm(`${product?.title||''} ${product?.vendor||''} ${(product?.tags||[]).join(' ')}`));
    }

    function cpuSocket(t){
      if(/\bAM5\b/.test(t)) return 'AM5'; if(/\bAM4\b/.test(t)) return 'AM4';
      if(/\bLGA\s?1851\b/.test(t)) return 'LGA1851'; if(/\bLGA\s?1700\b/.test(t)) return 'LGA1700'; if(/\bLGA\s?1200\b/.test(t)) return 'LGA1200';
      if(/RYZEN\s+(3|5|7|9)\s+(7\d{3}|8\d{3}|9\d{3})/.test(t) || /RYZEN\s+\d+\s+(7\d{3}|8\d{3}|9\d{3})/.test(t)) return 'AM5';
      if(/RYZEN\s+(3|5|7|9)\s+([1-5]\d{3})/.test(t) || /RYZEN\s+\d+\s+([1-5]\d{3})/.test(t)) return 'AM4';
      if(/CORE\s+ULTRA\s+[3579]\s+2\d{2}/.test(t)) return 'LGA1851';
      const m=t.match(/I[3579][ -]?(\d{4,5})/); if(m){ const g=Number(m[1].slice(0,m[1].length-3)); if(g>=12&&g<=14)return'LGA1700'; if(g===10||g===11)return'LGA1200'; }
      return '';
    }
    function boardSocket(t){
      if(/\bAM5\b/.test(t))return'AM5'; if(/\bAM4\b/.test(t))return'AM4'; if(/LGA\s?1851|\b(B860|H810|Z890)/.test(t))return'LGA1851'; if(/LGA\s?1700|\b(H610|B660|H670|Z690|B760|H770|Z790)/.test(t))return'LGA1700'; if(/LGA\s?1200|\b(H410|B460|H470|Z490|H510|B560|H570|Z590)/.test(t))return'LGA1200'; if(/\b(A620|B650|X670|B840|B850|X870)/.test(t))return'AM5'; if(/\b(A320|B350|X370|B450|X470|A520|B550|X570)/.test(t))return'AM4'; return'';
    }
    function memoryType(t){ if(/DDR\s?5|\bD5\b/.test(t))return'DDR5'; if(/DDR\s?4|\bD4\b/.test(t))return'DDR4'; return''; }
    function boardForm(t){ if(/MINI[- ]?ITX|\bITX\b/.test(t))return'ITX'; if(/MICRO[- ]?ATX|M[- ]?ATX|\bMATX\b/.test(t))return'MATX'; if(/\bE[- ]?ATX\b/.test(t))return'EATX'; if(/\bATX\b/.test(t))return'ATX'; return''; }
    function isComboCaseText(t){ return /PCBUILDER[_ -]?COMBO|COMBO[_ -]?CASE|CASE[_ -]?COMBO|PSU[_ -]?INCLUDED|WITH[_ -]?PSU|POWER SUPPLY INCLUDED|CASE\s*\+\s*PSU|\bCOMBO\b/.test(t); }
    function watts(t){ const ms=[...t.matchAll(/(\d{3,4})\s?W\b/g)].map(m=>Number(m[1])).filter(x=>x>=300&&x<=2000); return ms.length?Math.max(...ms):0; }
    function isThermalPasteText(t){ return /THERMAL\s*(PASTE|COMPOUND|GREASE)|THERMALPASTE|\bCPU\s*PASTE\b|\bHEATSINK\s*PASTE\b|\bMX[- ]?(2|4|5|6)\b|\bNT[- ]?H[12]\b/.test(t); }
    function coolerSockets(t){ return ['AM4','AM5','LGA1200','LGA1700','LGA1851'].filter(s=>t.includes(s)); }
    function requiredPsu(t){
      if(/RTX\s?5090/.test(t))return 1000; if(/RTX\s?5080/.test(t))return 850; if(/RTX\s?5070\s?TI/.test(t))return 850; if(/RTX\s?5070/.test(t))return 650; if(/RTX\s?5060\s?TI/.test(t))return 600; if(/RTX\s?5060|RTX\s?5050/.test(t))return 550;
      if(/RX\s?9070\s?XT/.test(t))return 750; if(/RX\s?9070/.test(t))return 650; if(/RX\s?9060\s?XT/.test(t))return 550; if(/RX\s?7900\s?XTX/.test(t))return 850; if(/RX\s?7900\s?XT/.test(t))return 750; if(/RX\s?7800\s?XT/.test(t))return 700; if(/RX\s?7700\s?XT/.test(t))return 700; if(/RX\s?7600/.test(t))return 550;
      if(/RTX\s?4090/.test(t))return 850; if(/RTX\s?4080/.test(t))return 750; if(/RTX\s?4070\s?TI/.test(t))return 700; if(/RTX\s?4070/.test(t))return 650; if(/RTX\s?4060/.test(t))return 550; return 0;
    }
    function gpuScore(t){
      const map=[['5090',100],['5080',91],['5070 TI',82],['5070',75],['5060 TI',66],['5060',60],['5050',52],['4090',89],['4080',80],['4070 TI',72],['4070',65],['4060 TI',56],['4060',50],['3090',67],['3080',60],['3070',50],['3060 TI',44],['3060',38],['3050',26],['9070 XT',79],['9070',72],['9060 XT',62],['7900 XTX',77],['7900 XT',70],['7800 XT',61],['7700 XT',55],['7600 XT',44],['7600',39],['6950 XT',62],['6900 XT',59],['6800 XT',54],['6700 XT',43],['6600 XT',34]];
      for(const [name,score] of map){ if(t.includes(name))return score; } return 0;
    }

    function passesCompatibility(key,p){
      const cpu=state.selected.cpu, mb=state.selected.motherboard, gpu=state.selected.gpu;
      if(key==='motherboard'&&cpu&&cpu.meta.socket&&p.meta.socket) return cpu.meta.socket===p.meta.socket;
      if(key==='cpu'&&mb&&mb.meta.socket&&p.meta.socket) return mb.meta.socket===p.meta.socket;
      if(key==='ram'&&mb&&mb.meta.ddr&&p.meta.ddr) return mb.meta.ddr===p.meta.ddr;
      if(key==='case'&&p.meta.combo&&gpu?.meta.psu&&p.meta.comboWatts) return p.meta.comboWatts>=gpu.meta.psu;
      if(key==='psu'&&gpu&&gpu.meta.psu&&p.meta.watts) return p.meta.watts>=gpu.meta.psu;
      if(key==='cooler'&&p.meta.thermal) return true;
      if(key==='cooler'&&cpu&&cpu.meta.socket&&p.meta.sockets&&p.meta.sockets.length) return p.meta.sockets.includes(cpu.meta.socket);
      return true;
    }

    function renderProducts(){
      const key=STEPS[state.step].key;
      if(key==='cpu'&&!state.cpuBrand){
        $('[data-products]').innerHTML='';
        $('[data-empty]').hidden=true;
        return;
      }
      let list=[...(state.products[key]||[])];
      const q=norm($('[data-search]').value.trim());
      const sort=$('[data-sort]').value;
      if(state.inStockOnly) list=list.filter(p=>p.available);
      if(key==='cpu'&&state.cpuBrand) list=list.filter(p=>detectCpuBrand(p)===state.cpuBrand);
      if(key==='case') list=list.filter(p=>state.caseTab==='combo'?p.meta.combo:!p.meta.combo);
      if(key==='cooler') list=list.filter(p=>state.coolerTab==='thermal'?p.meta.thermal:!p.meta.thermal);
      list=list.filter(p=>passesCompatibility(key,p));
      if(q) list=list.filter(p=>norm(`${p.title} ${p.vendor} ${(p.tags||[]).join(' ')}`).includes(q));
      if(sort==='price-asc')list.sort((a,b)=>a.price-b.price);
      else if(sort==='price-desc')list.sort((a,b)=>b.price-a.price);
      else if(sort==='name')list.sort((a,b)=>a.title.localeCompare(b.title));
      else list.sort((a,b)=>Number(b.available)-Number(a.available));
      const wrap=$('[data-products]');
      const empty=$('[data-empty]');
      empty.hidden=list.length>0;
      wrap.innerHTML=list.slice(0,120).map(p=>{
        const selectedProduct = key==='cooler'&&p.meta.thermal ? state.selected.thermal : state.selected[key];
        return productCard(p,selectedProduct?.variantId===p.variantId);
      }).join('');
      wrap.querySelectorAll('[data-product-id]').forEach(card=>{
        card.addEventListener('click',e=>{
          if(e.target.closest('a,[data-ram-qty]')) return;
          selectProduct(key,card.dataset.productId);
        });
        card.addEventListener('keydown',e=>{ if((e.key==='Enter'||e.key===' ')&&!e.target.closest('[data-ram-qty]')){e.preventDefault();selectProduct(key,card.dataset.productId);} });
      });
      wrap.querySelectorAll('[data-ram-qty]').forEach(btn=>btn.addEventListener('click',e=>{
        e.preventDefault();e.stopPropagation();
        changeRamQuantity(Number(btn.dataset.ramQty)||0);
      }));
    }

    function productCard(p,selected){
      const discount=p.discount>0?`<div class="qpc__discount-badge">Builder discount ${money(p.discount)}</div>`:'';
      const combo=p.key==='case'&&p.meta.combo?`<div class="qpc__combo-badge">PSU INCLUDED${p.meta.comboWatts?` · ${p.meta.comboWatts}W`:''}</div>`:'';
      const thermal=p.key==='cooler'&&p.meta.thermal?`<div class="qpc__thermal-badge">THERMAL PASTE</div>`:'';
      const ramQty=p.key==='ram'&&selected?`<div class="qpc__ram-qty" aria-label="RAM quantity"><button type="button" data-ram-qty="-1" aria-label="Decrease RAM quantity">−</button><strong>${itemQty(state.selected.ram)}</strong><button type="button" data-ram-qty="1" aria-label="Increase RAM quantity">+</button><small>pcs</small></div>`:'';
      return `<article class="qpc__product ${selected?'is-selected':''}" data-product-id="${esc(p.id)}" tabindex="0" role="button" aria-pressed="${selected?'true':'false'}">
        ${discount}${combo}${thermal}
        <div class="qpc__product-media">${p.image?`<img src="${esc(p.image)}" alt="${esc(p.title)}" loading="lazy">`:`<span class="qpc__no-image">NO IMAGE</span>`}</div>
        <div class="qpc__product-vendor">${esc(p.vendor||p.key)}</div><h3>${esc(p.title)}</h3>
        ${ramQty}
        <div class="qpc__product-bottom"><div><div class="qpc__product-price">${money(p.price)}${p.key==='ram'&&selected&&itemQty(state.selected.ram)>1?` <small>× ${itemQty(state.selected.ram)}</small>`:''}</div>${p.discount>0?`<div class="qpc__product-discount">Save ${money(p.discount)}${p.key==='ram'&&selected&&itemQty(state.selected.ram)>1?` × ${itemQty(state.selected.ram)}`:''} after confirmation</div>`:`<div class="qpc__product-stock">${p.available?'In stock':'Unavailable'}</div>`}</div><button class="qpc__select-product" type="button" aria-label="Select">${selected?'✓':'+'}</button></div>
      </article>`;
    }

    function changeRamQuantity(delta){
      const ram=state.selected.ram;
      if(!ram) return;
      const next=itemQty(ram)+delta;
      if(next<=0){ delete state.selected.ram; }
      else ram.quantity=Math.max(1,Math.min(4,next));
      renderProducts();
      renderSummary();
      renderStepsState();
    }

    function selectProduct(key,id){
      const p=(state.products[key]||[]).find(x=>String(x.id)===String(id));
      if(!p)return;
      if(key==='ram'){
        const current=state.selected.ram;
        state.selected.ram=current?.variantId===p.variantId ? current : {...p,quantity:1};
      } else if(key==='cooler'&&p.meta.thermal){
        state.selected.thermal=p;
      } else {
        state.selected[key]=p;
      }
      if(key==='cpu') state.cpuBrand=detectCpuBrand(p)||state.cpuBrand;
      if(key==='case'&&isComboCaseProduct(p)) delete state.selected.psu;
      sanitizeSelections(key);
      renderProducts();
      renderSummary();
      renderStepsState();
      const currentStep=state.step;
      const shouldStay = key==='ram' || (key==='cooler');
      const next=nextStepIndex(currentStep);
      if(!shouldStay&&next!==currentStep) setTimeout(()=>{ if(state.step===currentStep){state.step=next;updateBuilder();} },180);
    }

    function sanitizeSelections(changed){
      const cpu=state.selected.cpu, mb=state.selected.motherboard, gpu=state.selected.gpu, ram=state.selected.ram, psu=state.selected.psu, cooler=state.selected.cooler;
      if(cpu&&mb&&cpu.meta.socket&&mb.meta.socket&&cpu.meta.socket!==mb.meta.socket){ if(changed==='cpu')delete state.selected.motherboard; else delete state.selected.cpu; }
      const mb2=state.selected.motherboard;
      if(mb2&&ram&&mb2.meta.ddr&&ram.meta.ddr&&mb2.meta.ddr!==ram.meta.ddr) delete state.selected.ram;
      if(gpu&&psu&&gpu.meta.psu&&psu.meta.watts&&psu.meta.watts<gpu.meta.psu) delete state.selected.psu;
      const caseItem=state.selected.case;
      if(caseItem?.meta.combo){
        delete state.selected.psu;
        if(gpu?.meta.psu&&caseItem.meta.comboWatts&&caseItem.meta.comboWatts<gpu.meta.psu) delete state.selected.case;
      }
      const cpu2=state.selected.cpu;
      if(cpu2&&cooler&&cpu2.meta.socket&&cooler.meta.sockets?.length&&!cooler.meta.sockets.includes(cpu2.meta.socket)) delete state.selected.cooler;
    }

    function renderStepsState(){
      const active=activeStepIndices();
      $$('[data-step]').forEach((btn,i)=>{
        const p=state.selected[STEPS[i].key];
        const skipped=isStepSkipped(i);
        const number=active.indexOf(i)+1;
        btn.hidden=skipped;
        btn.classList.toggle('is-complete',!!p&&!skipped);
        btn.querySelector('.qpc__step-dot').textContent=p?'✓':String(Math.max(number,1)).padStart(2,'0');
        btn.querySelector('.qpc__step-price').textContent=p?(STEPS[i].key==='ram'&&itemQty(p)>1?`${itemQty(p)} × ${money(p.price)}`:money(p.price)):'';
      });
    }

    function selectionDiscount(selection){
      return Object.values(selection||{}).filter(Boolean).reduce((sum,p)=>sum+(p.discount||0)*itemQty(p),0);
    }

    function renderSummary(){
      const combo=comboCaseSelected();
      const visibleSteps=STEPS.filter(s=>!(s.key==='psu'&&combo));
      const selectedProducts=Object.values(state.selected||{}).filter(Boolean);
      const total=selectedProducts.reduce((a,p)=>a+p.price*itemQty(p),0);
      const discount=selectionDiscount(state.selected);
      const required=requiredKeys();
      const requiredSelected=required.filter(k=>state.selected[k]).length;
      $('[data-build-count]').textContent=`${requiredSelected} / ${required.length} required`;
      $('[data-total]').textContent=money(total);
      const summaryRows=STEPS.map(s=>{
        if(s.key==='psu'&&combo){
          const c=state.selected.case;
          return `<div class="qpc__summary-combo"><span>Power Supply</span><strong>Included with combo case${c?.meta?.comboWatts?` · ${c.meta.comboWatts}W`:''}</strong></div>`;
        }
        const p=state.selected[s.key];
        if(!p)return`<div class="qpc__summary-placeholder">${s.label} — not selected</div>`;
        const qty=itemQty(p);
        const amount=p.price*qty;
        return `<div class="qpc__summary-item"><div class="qpc__summary-item-media">${p.image?`<img src="${esc(p.image)}" alt="">`:''}</div><div><small>${s.label}${s.key==='ram'&&qty>1?` · ${qty} pcs`:''}</small><strong title="${esc(p.title)}">${esc(p.title)}</strong></div><div class="qpc__summary-price"><span>${qty>1?`${qty} × ${money(p.price)} = ${money(amount)}`:money(amount)}</span>${p.discount>0?`<small>-${money(p.discount*qty)}</small>`:''}</div></div>`;
      });
      if(state.selected.thermal){
        const p=state.selected.thermal;
        summaryRows.push(`<div class="qpc__summary-item qpc__summary-item--optional"><div class="qpc__summary-item-media">${p.image?`<img src="${esc(p.image)}" alt="">`:''}</div><div><small>Thermal Paste · optional</small><strong title="${esc(p.title)}">${esc(p.title)}</strong></div><div class="qpc__summary-price"><span>${money(p.price)}</span>${p.discount>0?`<small>-${money(p.discount)}</small>`:''}</div></div>`);
      }
      $('[data-summary-items]').innerHTML = selectedProducts.length ? summaryRows.join('') : '<div class="qpc__summary-placeholder">Start selecting components to build your system.</div>';
      const gpu=state.selected.gpu, mb=state.selected.motherboard, ram=state.selected.ram, psu=state.selected.psu, caseItem=state.selected.case;
      if(combo){
        $('[data-health-psu]').textContent=caseItem?.meta?.comboWatts?`Included · ${caseItem.meta.comboWatts}W`:'Included with case';
      } else {
        $('[data-health-psu]').textContent=gpu?.meta.psu?`${gpu.meta.psu}W+`:'—';
      }
      $('[data-health-ram]').textContent=ram?`${mb?.meta.ddr||ram?.meta.ddr||'RAM'} · ${itemQty(ram)} pcs`:(mb?.meta.ddr||'—');
      let compat='Ready';
      if(combo&&gpu?.meta.psu&&caseItem?.meta?.comboWatts&&caseItem.meta.comboWatts<gpu.meta.psu)compat='Combo PSU too low';
      else if(gpu?.meta.psu&&psu?.meta.watts&&psu.meta.watts<gpu.meta.psu)compat='PSU too low';
      $('[data-health-compat]').textContent=compat;
      const discountBox=$('[data-discount-summary]');
      discountBox.hidden=discount<=0;
      $('[data-discount-total]').textContent=money(discount);
      $('[data-discount-copy]').textContent=discount>0?`${discountMessage} · Estimated after confirmation: ${money(Math.max(0,total-discount))}`:discountMessage;
      const complete=required.every(k=>state.selected[k]);
      $('[data-add-cart]').disabled=!complete;
      $('[data-share-image]').disabled=!complete;
      $('[data-share-pdf]').disabled=!complete;
      syncCpuBrandUI();
      syncCategoryTabs();
    }

    async function setCartDiscountAttributes(discount){
      const value=discount>0?money(discount):'';
      const body={attributes:{
        'PC Builder Discount':value,
        'PC Builder Discount Status':discount>0?discountMessage:'',
        'PC Builder Discount Raw':discount>0?String(Math.round(discount)):''
      }};
      const res=await fetch(`${rootUrl}/cart/update.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',body:JSON.stringify(body)});
      if(!res.ok) throw new Error('Could not save builder discount to cart');
    }

    async function addSelectionToCart(selection){
      const products=Object.values(selection).filter(Boolean);
      if(!products.length)return;
      const discount=selectionDiscount(selection);
      const btn=$('[data-add-cart]');
      const old=btn?.textContent;
      if(btn){btn.disabled=true;btn.textContent='Adding build…';}
      try{
        const items=products.map((p,index)=>{
          const properties={'_Quantum Builder':'PC Builder'};
          if(p.key==='case'&&p.meta?.combo) properties['Power Supply']='Included with combo case'+(p.meta.comboWatts?` (${p.meta.comboWatts}W)`:'');
          if(p.key==='cooler'&&p.meta?.thermal) properties['Builder Add-on']='Thermal Paste';
          if(index===0&&discount>0){
            properties['PC Builder Discount']=money(discount);
            properties['Discount Status']=discountMessage;
          }
          return {id:p.variantId,quantity:itemQty(p),properties};
        });
        const res=await fetch(`${rootUrl}/cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',body:JSON.stringify({items})});
        if(!res.ok){
          let message='Could not add build';
          try{message=(await res.json()).description||message;}catch(_e){}
          throw new Error(message);
        }
        await setCartDiscountAttributes(discount);
        toast(discount>0?`Build added. Your confirmation discount is ${money(discount)}.`:'Complete build added to cart.');
        setTimeout(()=>location.href=`${rootUrl}/cart`,450);
      }catch(e){
        toast(e.message||'Could not add the build to cart.',true);
        if(btn){btn.disabled=false;btn.textContent=old;}
      }
    }

    function blobDownload(blob, filename){
      const url=URL.createObjectURL(blob);
      const a=document.createElement('a');
      a.href=url;a.download=filename;document.body.appendChild(a);a.click();a.remove();
      setTimeout(()=>URL.revokeObjectURL(url),1200);
    }

    async function shareFile(blob, filename, title){
      const file=new File([blob],filename,{type:blob.type});
      if(navigator.share && navigator.canShare?.({files:[file]})){
        await navigator.share({title,text:`${storeName} PC Build`,files:[file]});
        return true;
      }
      blobDownload(blob,filename);
      return false;
    }

    function wrapCanvasText(ctx,text,maxWidth){
      const words=String(text||'').split(/\s+/);const lines=[];let line='';
      for(const word of words){const test=line?`${line} ${word}`:word;if(ctx.measureText(test).width>maxWidth&&line){lines.push(line);line=word;}else line=test;}
      if(line)lines.push(line);return lines;
    }

    async function loadCanvasImage(url){
      if(!url)return null;
      return await new Promise(resolve=>{const img=new Image();img.crossOrigin='anonymous';img.onload=()=>resolve(img);img.onerror=()=>resolve(null);img.src=url;});
    }

    async function buildShareCanvas(selection){
      const combo=isComboCaseProduct(selection.case);
      const steps=STEPS.filter(s=>!(s.key==='psu'&&combo));
      const rows=steps.map(s=>({step:s,product:selection[s.key]})).filter(r=>r.product || (r.step.key==='psu'&&combo));
      if(selection.thermal) rows.push({step:{key:'thermal',label:'Thermal Paste'},product:selection.thermal});
      const canvas=document.createElement('canvas');canvas.width=1080;canvas.height=Math.max(1350,390+rows.length*112+180);
      const ctx=canvas.getContext('2d');
      const bg=ctx.createLinearGradient(0,0,1080,canvas.height);bg.addColorStop(0,'#070b10');bg.addColorStop(.55,'#0c1420');bg.addColorStop(1,'#090d13');ctx.fillStyle=bg;ctx.fillRect(0,0,1080,canvas.height);
      ctx.fillStyle='#5cf2ff';ctx.fillRect(64,58,96,7);
      ctx.fillStyle='#ffffff';ctx.font='800 48px Arial, sans-serif';ctx.fillText(storeName.toUpperCase(),64,132);
      ctx.fillStyle='#5cf2ff';ctx.font='800 25px Arial, sans-serif';ctx.fillText('PC BUILD CONFIGURATION',64,176);
      ctx.fillStyle='#8d9aad';ctx.font='20px Arial, sans-serif';ctx.fillText('Live store configuration • '+new Date().toLocaleDateString('en-GB'),64,214);
      const total=Object.values(selection||{}).filter(Boolean).reduce((a,p)=>a+p.price*itemQty(p),0);
      const discount=selectionDiscount(selection);
      const effective=Math.max(0,total-discount);
      ctx.textAlign='right';ctx.fillStyle='#ffffff';ctx.font='800 42px Arial, sans-serif';ctx.fillText(money(total),1016,130);
      ctx.fillStyle='#8d9aad';ctx.font='18px Arial, sans-serif';ctx.fillText('Checkout total',1016,166);
      if(discount>0){ctx.fillStyle='#86efac';ctx.font='800 20px Arial, sans-serif';ctx.fillText(`Discount after confirmation: ${money(discount)}`,1016,202);}
      ctx.textAlign='left';
      let y=270;const rowH=112;
      for(const row of rows){
        const p=row.product;
        ctx.fillStyle='rgba(255,255,255,.045)';ctx.fillRect(60,y,960,rowH-10);
        ctx.fillStyle='#5cf2ff';ctx.font='800 16px Arial, sans-serif';ctx.fillText(row.step.label.toUpperCase(),82,y+30);
        if(row.step.key==='psu'&&combo){
          const c=selection.case;ctx.fillStyle='#eaf1f8';ctx.font='700 22px Arial, sans-serif';ctx.fillText(`Included with combo case${c?.meta?.comboWatts?` • ${c.meta.comboWatts}W`:''}`,82,y+67);
        }else if(p){
          const img=await loadCanvasImage(p.image);
          if(img){ctx.fillStyle='#ffffff';ctx.fillRect(82,y+40,62,52);const scale=Math.min(54/img.width,44/img.height);const w=img.width*scale,h=img.height*scale;ctx.drawImage(img,82+(62-w)/2,y+44+(44-h)/2,w,h);}
          const tx=img?164:82;ctx.fillStyle='#eaf1f8';ctx.font='700 20px Arial, sans-serif';const qty=itemQty(p);const title=qty>1?`${p.title} × ${qty}`:p.title;const lines=wrapCanvasText(ctx,title,650).slice(0,2);lines.forEach((line,i)=>ctx.fillText(line,tx,y+58+i*25));
          ctx.textAlign='right';ctx.fillStyle='#ffffff';ctx.font='800 22px Arial, sans-serif';ctx.fillText(money(p.price*qty),992,y+62);if(p.discount>0){ctx.fillStyle='#86efac';ctx.font='700 15px Arial, sans-serif';ctx.fillText(`-${money(p.discount*qty)}`,992,y+86);}ctx.textAlign='left';
        }
        y+=rowH;
      }
      const footerY=Math.min(canvas.height-110,y+28);
      ctx.fillStyle='#5cf2ff';ctx.fillRect(60,footerY-8,960,2);
      ctx.fillStyle='#ffffff';ctx.font='800 26px Arial, sans-serif';ctx.fillText(`TOTAL ${money(total)}`,60,footerY+40);
      if(discount>0){ctx.fillStyle='#86efac';ctx.font='700 20px Arial, sans-serif';ctx.fillText(`Estimated after confirmation: ${money(effective)}`,60,footerY+74);}
      ctx.textAlign='right';ctx.fillStyle='#7f8da1';ctx.font='16px Arial, sans-serif';ctx.fillText('Prices and availability may change before order confirmation.',1020,footerY+72);ctx.textAlign='left';
      return canvas;
    }

    function dataUrlToBytes(dataUrl){
      const b64=dataUrl.split(',')[1];const bin=atob(b64);const out=new Uint8Array(bin.length);for(let i=0;i<bin.length;i++)out[i]=bin.charCodeAt(i);return out;
    }

    function concatBytes(parts){
      const len=parts.reduce((a,p)=>a+p.length,0);const out=new Uint8Array(len);let off=0;for(const p of parts){out.set(p,off);off+=p.length;}return out;
    }

    function canvasToPdfBlob(canvas){
      const enc=new TextEncoder();const jpeg=dataUrlToBytes(canvas.toDataURL('image/jpeg',.92));
      const pageW=612,pageH=Math.round(pageW*canvas.height/canvas.width);
      const content=`q\n${pageW} 0 0 ${pageH} 0 0 cm\n/Im0 Do\nQ\n`;
      const objects=[
        null,
        enc.encode('<< /Type /Catalog /Pages 2 0 R >>'),
        enc.encode('<< /Type /Pages /Kids [3 0 R] /Count 1 >>'),
        enc.encode(`<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ${pageW} ${pageH}] /Resources << /XObject << /Im0 5 0 R >> >> /Contents 4 0 R >>`),
        enc.encode(`<< /Length ${enc.encode(content).length} >>\nstream\n${content}endstream`),
        concatBytes([enc.encode(`<< /Type /XObject /Subtype /Image /Width ${canvas.width} /Height ${canvas.height} /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ${jpeg.length} >>\nstream\n`),jpeg,enc.encode('\nendstream')])
      ];
      const parts=[enc.encode('%PDF-1.4\n')];const offsets=[0];let size=parts[0].length;
      for(let i=1;i<objects.length;i++){offsets[i]=size;const head=enc.encode(`${i} 0 obj\n`),tail=enc.encode('\nendobj\n');parts.push(head,objects[i],tail);size+=head.length+objects[i].length+tail.length;}
      const xrefOffset=size;let xref=`xref\n0 ${objects.length}\n0000000000 65535 f \n`;for(let i=1;i<objects.length;i++)xref+=`${String(offsets[i]).padStart(10,'0')} 00000 n \n`;
      const trailer=`trailer\n<< /Size ${objects.length} /Root 1 0 R >>\nstartxref\n${xrefOffset}\n%%EOF`;
      parts.push(enc.encode(xref+trailer));return new Blob([concatBytes(parts)],{type:'application/pdf'});
    }

    async function shareBuild(selection,format){
      const required=requiredKeysForSelection(selection);
      if(!required.every(k=>selection[k])){toast('Complete the required build parts before sharing.',true);return;}
      const canvas=await buildShareCanvas(selection);
      const stamp=new Date().toISOString().slice(0,10);const base=`quantum-pc-build-${stamp}`;
      try{
        if(format==='pdf'){
          const blob=canvasToPdfBlob(canvas);await shareFile(blob,`${base}.pdf`,`${storeName} PC Build`);toast('PDF ready to share.');
        }else{
          const blob=await new Promise(resolve=>canvas.toBlob(resolve,'image/png',.96));if(!blob)throw new Error('Could not generate image');await shareFile(blob,`${base}.png`,`${storeName} PC Build`);toast('Build image ready to share.');
        }
      }catch(err){console.error('[Quantum PC Builder share]',err);toast('Could not create the share file on this browser.',true);}
    }

    function requiredKeysForSelection(selection){
      const keys=['cpu','motherboard','gpu','ram','storage','case'];
      if(!isComboCaseProduct(selection.case))keys.push('psu');
      return keys;
    }

    function bindAuto(){
      $('[data-auto-form]').addEventListener('submit',async e=>{
        e.preventDefault();
        const form=new FormData(e.currentTarget);
        const budget=num(form.get('budget'));
        if(budget<10000){toast('Enter a valid build budget.',true);return;}
        const submit=e.currentTarget.querySelector('button[type=submit]');
        submit.disabled=true; submit.textContent='Building…';
        try{
          await Promise.all(STEPS.map(s=>ensureProducts(s.key)));
          const build=autoBuild({use:form.get('use'),target:form.get('target'),gpu:form.get('gpu'),budget});
          state.generated=build;
          renderGenerated(build,'auto');
        } finally {
          submit.disabled=false;submit.textContent='Generate my build';
        }
      });
    }

    function autoBuild(cfg){
      const weights={gaming:{cpu:.17,motherboard:.09,gpu:.40,ram:.08,storage:.08,psu:.07,case:.06,cooler:.05},editing:{cpu:.26,motherboard:.10,gpu:.28,ram:.10,storage:.09,psu:.07,case:.05,cooler:.05},'3d':{cpu:.22,motherboard:.09,gpu:.34,ram:.10,storage:.08,psu:.07,case:.05,cooler:.05},streaming:{cpu:.22,motherboard:.09,gpu:.34,ram:.09,storage:.08,psu:.07,case:.06,cooler:.05}}[cfg.use];
      const w={...weights};
      if(cfg.target==='4k'){w.gpu+=.07;w.cpu-=.04;w.case-=.02;w.cooler-=.01;}
      if(cfg.target==='1080p'){w.cpu+=.04;w.gpu-=.03;w.case-=.01;}
      if(cfg.target==='productivity'){w.cpu+=.06;w.gpu-=.04;w.case-=.01;w.cooler-=.01;}
      const pick={};
      let cpuCandidates=available('cpu').filter(p=>p.meta.socket); pick.cpu=pickNear(cpuCandidates,cfg.budget*w.cpu);
      let boardCandidates=available('motherboard').filter(p=>!pick.cpu?.meta.socket||!p.meta.socket||p.meta.socket===pick.cpu.meta.socket); pick.motherboard=pickNear(boardCandidates,cfg.budget*w.motherboard);
      let gpuCandidates=available('gpu').filter(p=>cfg.gpu==='any'||p.meta.brand===cfg.gpu); pick.gpu=pickNear(gpuCandidates,cfg.budget*w.gpu);
      let ramCandidates=available('ram').filter(p=>!pick.motherboard?.meta.ddr||!p.meta.ddr||p.meta.ddr===pick.motherboard.meta.ddr); pick.ram=pickNear(ramCandidates,cfg.budget*w.ram);
      pick.storage=pickNear(available('storage'),cfg.budget*w.storage);
      const caseCandidates=available('case').filter(p=>!p.meta.combo||!p.meta.comboWatts||!pick.gpu?.meta.psu||p.meta.comboWatts>=pick.gpu.meta.psu);
      pick.case=pickNear(caseCandidates,cfg.budget*(w.case+(caseCandidates.some(p=>p.meta.combo)?w.psu*.45:0)));
      if(!pick.case?.meta.combo){
        let psuCandidates=available('psu').filter(p=>!pick.gpu?.meta.psu||!p.meta.watts||p.meta.watts>=pick.gpu.meta.psu); pick.psu=pickNear(psuCandidates,cfg.budget*w.psu);
      }
      let coolerCandidates=available('cooler').filter(p=>!p.meta.thermal).filter(p=>!pick.cpu?.meta.socket||!p.meta.sockets?.length||p.meta.sockets.includes(pick.cpu.meta.socket)); pick.cooler=pickNear(coolerCandidates,cfg.budget*w.cooler);
      trimToBudget(pick,cfg.budget);
      return {items:pick,budget:cfg.budget,total:Object.values(pick).filter(Boolean).reduce((a,p)=>a+p.price,0),note:'Generated from live store inventory using a deterministic budget and compatibility model.'};
    }
    function available(key){ return (state.products[key]||[]).filter(p=>!state.inStockOnly||p.available).filter(p=>p.price>0); }
    function pickNear(list,target){ if(!list.length)return null; const under=list.filter(p=>p.price<=target).sort((a,b)=>b.price-a.price); if(under.length)return under[0]; return [...list].sort((a,b)=>a.price-b.price)[0]; }
    function trimToBudget(pick,budget){
      const order=['case','cooler','storage','ram','motherboard','cpu','gpu'];
      let total=()=>Object.values(pick).filter(Boolean).reduce((a,p)=>a+p.price,0);
      let guard=0;
      while(total()>budget&&guard++<30){
        let changed=false;
        for(const key of order){
          const cur=pick[key]; if(!cur)continue;
          let candidates=available(key).filter(p=>p.price<cur.price);
          if(key==='cooler')candidates=candidates.filter(p=>!p.meta.thermal);
          if(key==='motherboard'&&pick.cpu?.meta.socket)candidates=candidates.filter(p=>!p.meta.socket||p.meta.socket===pick.cpu.meta.socket);
          if(key==='ram'&&pick.motherboard?.meta.ddr)candidates=candidates.filter(p=>!p.meta.ddr||p.meta.ddr===pick.motherboard.meta.ddr);
          if(key==='psu'&&pick.gpu?.meta.psu)candidates=candidates.filter(p=>!p.meta.watts||p.meta.watts>=pick.gpu.meta.psu);
          if(!candidates.length)continue;
          const next=candidates.sort((a,b)=>b.price-a.price)[0];
          pick[key]=next;changed=true;break;
        }
        if(!changed)break;
      }
    }

    function renderGenerated(build,type){
      const el=type==='auto'?$('[data-auto-result]'):$('[data-upgrade-result]');
      const items=Object.entries(build.items||{}).filter(([,p])=>p);
      const discount=selectionDiscount(build.items||{});
      el.hidden=false;
      el.innerHTML=`<div class="qpc__generated-head"><div><div class="qpc__step-kicker">${type==='auto'?'RECOMMENDED BUILD':'UPGRADE SHORTLIST'}</div><h3>${type==='auto'?'Your balanced Quantum build':'Recommended next moves'}</h3><p>${esc(build.note||'')}</p></div><div class="qpc__generated-total"><small>${type==='auto'?'TOTAL':'ESTIMATED TOTAL'}</small><strong>${money(build.total||0)}</strong>${discount>0?`<em>Builder discount ${money(discount)}</em>`:''}</div></div>
      <div class="qpc__generated-grid">${items.map(([key,p])=>`<div class="qpc__generated-item"><small>${esc(STEPS.find(s=>s.key===key)?.label||key)}</small><strong title="${esc(p.title)}">${esc(p.title)}</strong><span>${money(p.price)}</span>${p.discount>0?`<em>-${money(p.discount)} after confirmation</em>`:''}</div>`).join('')}</div>
      ${build.warning?`<div class="qpc__generated-warning">${esc(build.warning)}</div>`:''}
      <div class="qpc__generated-actions"><button type="button" class="qpc__button qpc__button--primary" data-use-generated>${type==='auto'?'Customize this build':'Open in builder'}</button><button type="button" class="qpc__button qpc__button--ghost" data-cart-generated>Add these items to cart</button>${type==='auto'?'<button type="button" class="qpc__button qpc__button--ghost" data-image-generated>Share as image</button><button type="button" class="qpc__button qpc__button--ghost" data-pdf-generated>Share as PDF</button>':''}</div>`;
      el.querySelector('[data-use-generated]').addEventListener('click',()=>{
        state.selected={...build.items};
        if(state.selected.ram&&!state.selected.ram.quantity) state.selected.ram={...state.selected.ram,quantity:1};
        state.cpuBrand=detectCpuBrand(state.selected.cpu)||'';
        state.step=0;
        root.querySelector('[data-mode="builder"]').click();
        updateBuilder();
        window.scrollTo({top:root.offsetTop+160,behavior:'smooth'});
      });
      el.querySelector('[data-cart-generated]').addEventListener('click',()=>addSelectionToCart(build.items));
      el.querySelector('[data-image-generated]')?.addEventListener('click',()=>shareBuild(build.items,'image'));
      el.querySelector('[data-pdf-generated]')?.addEventListener('click',()=>shareBuild(build.items,'pdf'));
      el.scrollIntoView({behavior:'smooth',block:'nearest'});
    }

    function bindUpgrade(){
      $('[data-upgrade-form]').addEventListener('submit',async e=>{
        e.preventDefault();
        const f=new FormData(e.currentTarget);
        const budget=num(f.get('budget'));
        if(budget<3000){toast('Enter a valid upgrade budget.',true);return;}
        const submit=e.currentTarget.querySelector('button[type=submit]');
        submit.disabled=true;submit.textContent='Analyzing…';
        try{
          await Promise.all(['cpu','gpu','psu'].map(ensureProducts));
          const result=upgradePath({cpu:f.get('cpu'),motherboard:f.get('motherboard'),gpu:f.get('gpu'),psu:f.get('psu'),target:f.get('target'),budget});
          state.upgrade=result;renderGenerated(result,'upgrade');
        } finally {
          submit.disabled=false;submit.textContent='Find my upgrade path';
        }
      });
    }

    function upgradePath(cfg){
      const items={};
      const curGpu=gpuScore(norm(cfg.gpu));
      const currentSocket=boardSocket(norm(cfg.motherboard))||cpuSocket(norm(cfg.cpu));
      const currentPsu=watts(norm(cfg.psu));
      const targetMin={'1080p':50,'1440p':62,'4k':78,productivity:60}[cfg.target]||60;
      const gpuBudget=cfg.target==='productivity'?cfg.budget*.55:cfg.budget*.68;
      let gpuCandidates=available('gpu').filter(p=>p.meta.score>Math.max(curGpu,targetMin-8)&&p.price<=gpuBudget).sort((a,b)=>b.meta.score-a.meta.score||b.price-a.price);
      if(!gpuCandidates.length)gpuCandidates=available('gpu').filter(p=>p.meta.score>curGpu&&p.price<=cfg.budget).sort((a,b)=>b.meta.score-a.meta.score||b.price-a.price);
      items.gpu=gpuCandidates[0]||null;
      let remaining=cfg.budget-(items.gpu?.price||0);
      if(remaining>4000){ let cpus=available('cpu').filter(p=>p.price<=remaining && (!currentSocket||!p.meta.socket||p.meta.socket===currentSocket)).sort((a,b)=>b.price-a.price); if(cpus.length)items.cpu=cpus[0]; }
      const needPsu=items.gpu?.meta.psu||0;
      if(needPsu && currentPsu && currentPsu<needPsu){ let remaining2=cfg.budget-Object.values(items).filter(Boolean).reduce((a,p)=>a+p.price,0); let psus=available('psu').filter(p=>p.price<=remaining2&&(!p.meta.watts||p.meta.watts>=needPsu)).sort((a,b)=>a.price-b.price); if(psus.length)items.psu=psus[0]; }
      const total=Object.values(items).filter(Boolean).reduce((a,p)=>a+p.price,0);
      let warning='';
      if(!currentSocket)warning+='Motherboard socket could not be identified, so CPU compatibility must be checked manually. ';
      if(items.gpu?.meta.psu&&!currentPsu)warning+=`The selected GPU is typically paired with a ${items.gpu.meta.psu}W+ PSU; your PSU wattage was not detected.`;
      else if(items.gpu?.meta.psu&&currentPsu<items.gpu.meta.psu)warning+=`Your entered PSU appears below the ${items.gpu.meta.psu}W recommendation; a PSU upgrade was included when budget allowed.`;
      if(!items.gpu&&!items.cpu)warning+='No clear in-stock upgrade was found inside the entered budget.';
      return {items,budget:cfg.budget,total,note:'Prioritized by target performance, current platform hints, live price and available budget.',warning:warning.trim()};
    }
  }
})();
